import { createAsyncThunk } from '@reduxjs/toolkit';
import { Region } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchRegion, FindRegion, GetRegion } from './interface';

export const createRegion = createAsyncThunk(
  'region/createRegion',
  async (values: CreatePatchRegion, { rejectWithValue }) => {
    try {
      const response = await Region.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const findRegion = createAsyncThunk('region/findRegion', async (values: FindRegion, { rejectWithValue }) => {
  try {
    const response = await Region.find({
      query: values,
    });

    return response;
  } catch (error: any) {
    toastHandler(error);
    return rejectWithValue(error.message);
  }
});

export const getRegion = createAsyncThunk(
  'region/getRegion',
  async ({ id }: GetRegion, { rejectWithValue }) => {
    try {
      const response = await Region.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchRegion = createAsyncThunk(
  'region/patchRegion',
  async ({ id, ...values }: CreatePatchRegion, { rejectWithValue }) => {
    try {
      const response = await Region.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
